export enum TipoCuentaAbonoEnum {
    CUENTA_PROPIA = 'CUENTA_PROPIA',
    CUENTA_TERCEROS = 'CUENTA_TERCEROS',
    CUENTA_EMPRESA = 'CUENTA_EMPRESA'
}
